import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Util } from 'src/shared/util/util';

@Component({
  selector: 'tidy-initials-icon',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'initials-icon.component.html',
  styleUrls: ['./initials-icon.component.scss'],
})

export class InitialsIconComponent implements OnInit, OnChanges {

  @Input() fullName: string;
  @Input() size: string = 'medium';
  @Input() isUnknownNumber: boolean = false;
  nameInitials: string = '';
  constructor(public util: Util) {}

  ngOnInit(): void {
    this.nameInitials = this.parseInitials(this.fullName);
    if (/\d/.test(this.nameInitials)) {
      this.isUnknownNumber = true;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.nameInitials = this.parseInitials(changes.fullName.currentValue);
    if (/\d/.test(this.nameInitials)) {
      this.isUnknownNumber = true;
    }
  }

  parseInitials(fullName): string {
    if (!fullName) {
      return '';
    }
    return fullName
      .match(/(\b\S)?/g)
      .join('')
      .match(/(^\S|\S$)?/g)
      .join('')
      .toUpperCase();
  }
}
